import './AppWrapper.style.less'
import { memo, useState } from 'react'
import { Alert } from 'antd'
import CheckConnection from '@/components/CheckConnection/CheckConnection'
import LoadingComponent from '../LoadingComponent/LoadingComponent'
import { ThemeContext } from './AppWrapper.context'
import { alertAtom } from '@/jotai/alert.jotai'
import { loadingAtom } from '../../jotai/loading.jotai'
import { useAtom } from 'jotai'

interface Props {
  children: any
}

function AppWrapper(props: Props) {
  const [alert] = useAtom(alertAtom)
  const [isLoading] = useAtom(loadingAtom)
  const [theme, settheme] = useState('light')

  return (
    <>
      <ThemeContext.Provider value={{ theme, settheme }}>
        <div data-theme={theme}>
          <CheckConnection />
          {isLoading && <LoadingComponent />}
          {alert && (
            <div
              style={{
                border: 'none',
                zIndex: 11,
                position: 'fixed',
                width: 300,
                left: 0,
                margin: 10,
              }}
            >
              <Alert message="Something went wrong" type="error" closable />
            </div>
          )}
          {props.children}
        </div>
      </ThemeContext.Provider>
    </>
  )
}

export default memo(AppWrapper)
